import { getUser } from '../../shared/auth-service';
import { getUserData } from '../../shared/info-device';
import { 
    getShiftAbbreviations,
    getAbbreviationsTypes,
    sendNewAbbreviated,
    sendUpdateAbbreviation,
    sendDeleteAbbreviation,
    getCheckAbbreviationExistence
} from '../../shared/data-services/shift-service';


export async function getAbbreviation(companyId){
   
    const data = await getShiftAbbreviations(companyId);
    return data;
};

export async function getAbbreviationType(companyId){
    const data = await getAbbreviationsTypes(companyId);
    return data;
};

export async function saveNewAbbreviated(dataForm,companyId){
    const { employeeId: user } = getUser();
    //const { userdata: { ip } } = await getUserData();
    const ip = '';
    const userAgent = navigator.userAgent;

    const params = {...dataForm, userAgent, user, ip,companyId};
    const data = await sendNewAbbreviated(params);
    return data;
};

export async function saveUpdateAbbreviated(dataEdit,companyId){
    const { employeeId: user } = getUser();
    //const { userdata: { ip } } = await getUserData();
    const ip = '';
    const userAgent = navigator.userAgent;
    const params = {...dataEdit, userAgent, user, ip,companyId};

    const data = await sendUpdateAbbreviation(params);
    return data;
};

export async function deleteAbbreviation(shiftAbbreviationId){
    const { employeeId: user } = getUser();
    //const { userdata: { ip } } = await getUserData();
    const ip = '';
    const userAgent = navigator.userAgent;

    const params = { shiftAbbreviationId, userAgent, user, ip }
    const data = await sendDeleteAbbreviation(params);
    return data;
};

export async function GetCheckAbbreviationExistence(code,companyId){
    const data = await getCheckAbbreviationExistence(code,companyId);
    return data;
};